<template>
  <div class="flowchart">
    <div class="container">
      <Button
        theme="yellow"
        arrow="begin"
        shape="minimal"
        class="back"
      >
        <router-link to="/">
          <span class="slot">Terug naar begin</span>
        </router-link>
      </Button>

      <ul
        class="steps"
        v-if="steps"
      >
        <li
          v-for="(step, index) in steps"
          :key="index"
          class="step"
          :class="{
            'step--active': $route.fullPath === step.route,
            'step--end': index === (steps.length - 1)
          }"
        >

          <router-link :to="step.route">
            <div
              class="shape"
              :class="{
                'shape--active': $route.fullPath === step.route,
                'shape--begin': index === 0,
                'shape--end': index === (steps.length - 1)
              }"
            ></div>

            <span class="title">
              {{ step.flowTitle }}
            </span>
          </router-link>

          <template v-for="button in step.buttons">
            <div
              v-if="button.modal"
              class="reject"
              :class="{
                'reject--end': index === (steps.length - 1)
              }"
            ></div>
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'Flowchart',
  components: { Button },
  props: {
    type: {
      type: String,
      required: true
    },
    json: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      steps: []
    }
  },
  methods: {
    setSteps (steps) {
      this.steps = steps.filter(step => step.flow)
    }
  },
  created () {
    this.setSteps(this.json)
  }
}
</script>

<style lang="scss" scoped>
  .flowchart {
  }
  .container {
    padding-top: 46px;
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .back, .steps {
    display: inline-block;
    font-size: 0;
    vertical-align: top;

    @media (max-width: 1380px) {
      display: block;
    }
  }
  .back + .steps {
    margin-left: 87px;

    @media (max-width: 1380px) {
      margin-left: 0;
    }
  }
  .back {
    padding-top: 0;
    padding-bottom :0;

    @media (max-width: 1380px) {
      display: none !important;
    }
  }
  .steps {
    padding: 0;
    margin: 0;
    list-style-type: none;
    font-size: 0;
  }
  .step {
    margin: 0;
    display:inline-block;
    width: 120px;
    vertical-align: top;
    position: relative;
    z-index: 30;

    @media (max-width: 1380px) {
      display: block;
      width: 100%;
      height: 80px;
    }

    &--end {
      width: 20px;
    }
  }
  .shape {
    width: 20px;
    height: 20px;
    position: relative;
    z-index: 20;

    &:before, &:after {
      content: "";
      position: absolute;
    }
    &:before {
      background-color: white;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      border-radius: 50%;
      z-index: 20;
      transition: background-color 200ms ease-in-out;
    }
    &:after {
      content: "";
      height: 1px;
      width: 120px;
      position: absolute;
      left: 0;
      top: 10px;
      background-color: black;
      z-index: 10;

      @media (max-width: 1380px) {
        height: 80px;
        width: 1px;
        left: 10px;
        top: 0; 
      }
    }

    &--active {

      &:before {
        background-color: black;
      }
    }
    &--begin {

    }
    &--end {
      left: -2px;

      @media (max-width: 1380px) {
        left: 0;
        top: -2px;
      }

      &:before {
        border-radius: 0;
        top: 2px;
        left: 2px;
        bottom: 2px;
        right: 2px;
      }
      &:after {
        display: none;
      }
    }
  }
  .title {
    font-size: 16px;
    line-height: 1.23;
    position: absolute;
    text-align: center;
    left: -50px; // Half of 120 minus half of the shape
    width: 120px;
    top: 34px;
    opacity: 1;
    transition: all .8s cubic-bezier(.19,1,.22,1);
    transition-property: left, opacity;

    @media (max-width: 1380px) {
      left: 45px;
      top: 3px;
      text-align: left;
    }
    @media (max-width: 600px) {
      opacity: 0;
      left: 60px;
    }
  }
  .reject {
    position: absolute;
    width: 16px;
    height: 16px;
    background-color: white;
    left: 64px;
    top: -21px;
    z-index: 10;

    @media (max-width: 1380px) {
      top: 33px;
      left: 20px;
    }

    &:before, &:after {
      content: "";
      position: absolute;
      background-color: black;
    }
    &:before {
      height: 14px;
      width: 1px;
      left: -54px;
      bottom: -7px;

      @media (max-width: 1380px) {
        height: 1px;
        width: 22px;
        left: -14px;
        top: -23px;
      }
    }
    &:after {
      height: 1px;
      width: 54px;
      bottom: 7px;
      left: -54px;

      @media (max-width: 1380px) {
        height: 23px;
        width: 1px;
        top: -23px;
        left: 8px;
      }
    }

    &--end {
      margin-left: -2px;

      @media (max-width: 1380px) {
        margin-left: 0;
        margin-top: -2px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Flow/components/Flowchart.vue